// extracted by mini-css-extract-plugin
export var lightMode = "_u-0";